import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";

const initialState = {
  language: 'en'
};

function changeLanguage(state, action) {
  return updateObject(state, {
    language: action.langIsoCode
  });
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.settings.CHANGE_LANGUAGE:
      return changeLanguage(state, action);
    default:
      return state;
  }
}